import { Text } from "@chakra-ui/react";
import { cn } from "utils/helpers";

export const SmartFieldNote = ({ type, className }) => {
	return (
		<div className={cn("rounded-md bg-blue-100/70 px-6 py-5", className)}>
			<Text className="text-text-secondary-700">
				Please note that any changes made will{" "}
				<span className="font-medium">only affect this RFX</span> and not the
				main {type} in your profile.
			</Text>
		</div>
	);
};
